import { get } from 'lodash';

export const getState = (state, param = null, defaultValue = null) => get(state, `inventory.create${(param ? '.'+param : '')}`, defaultValue);
